/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	// equalizer firefox bug
	function reinit_equalizer(){
		Foundation.reInit('equalizer');
	}
	
	$('.row').each(function() {
		if (typeof $(this).data('equalizer') !== 'undefined') {
			window.onload=reinit_equalizer();
		} 
	});
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// allow second tap on mobile/tablet menu to open parent url
	jQuery('.menu-item-has-children > a').click(function(){
	    jQuery(this).unbind('click');
	});

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	jQuery('iframe[data-src*="youtube.com"], iframe[data-src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	socialToggle();
	
}); 

function socialToggle() {
	jQuery('.social-wrap a').click( function(e) {
		e.preventDefault();

		var shareMethod = jQuery( this ).data( 'social' );
		if ( shareMethod == 'linkedin' ) {
			loadLinkedinShare( jQuery( this ).data( 'url' ) );
		} else if ( shareMethod == 'twitter' ) {
			loadTwitterShare( jQuery( this ).data( 'url' ), jQuery( this ).data( 'text' ) );
		} 
	});
}

function loadLinkedinShare( url ) {
	var strWindowFeatures = "location=yes,height=436,width=626,scrollbars=yes,status=yes";
	var URL = "http://www.linkedin.com/shareArticle?mini=true"+
	"&url=" + url;
	return window.open(URL, "_blank", strWindowFeatures);
}

function loadTwitterShare( url, text ) {
	var strWindowFeatures = "location=yes,height=400,width=685,scrollbars=yes,status=yes";
	var URL = "https://twitter.com/intent/tweet?" +
		"&text=" + text +
		"&url=" + url +
		"&via=thePSCI";
	sendSocialEvent(petaGA_SNsource_Twitter, 'Share', url);
	return window.open(URL, "_blank", strWindowFeatures);
}